import React, {FunctionComponent} from "react";
import Icon, {IconProps} from "../icon/Icon";

export type FormLayoutTitleProps = {
    children: React.ReactNode;
    icon?: IconProps;
};

const FormLayoutTitle: FunctionComponent<FormLayoutTitleProps> = ({children, icon}) => {
    return (
        <div className="form-layout__title h3">
            {icon && <Icon {...icon}/>}
            {children}
        </div>
    );
};

export default FormLayoutTitle;
